/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import DHBMembers from "views/DHBMembers"
import DonHang from "views/DonHang"
import Orders from "views/Orders"
import LichSu from "views/LichSu"
import CapNhap from "views/Update"
import NgonNgu from "views/Language"
import AuthService from "services/auth.service"

import UserV1 from "views/DHBLayoutSideBar"
import UserV3 from "views/User.v3"
import OrderIDDetails from "components/Childrens/OrderIDDetails"

import DashboardX from "views/Dashboard.js";

import Tool from "services/tool.service"

import routes from "routes.js";

var ps;

class Dashboard extends React.Component {
	constructor(props) {
		super(props);
		const now = new Date();
		const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
		this.state = {
			backgroundColor: "black",
			activeColor: "info",
			newRoutes: [],
			selectedMonth: currentMonth
		};
		this.mainPanel = React.createRef();
		this.handleMonthChange = this.handleMonthChange.bind(this);
	}
	componentDidMount() {
		// if (navigator.platform.indexOf("Win") > -1) {
		//   ps = new PerfectScrollbar(this.mainPanel.current);
		//   document.body.classList.toggle("perfect-scrollbar-on");
		// }
		this.logged()
		this.administratorPrivileges()
		this.getToolFromServer()
	}
	componentWillUnmount() {
		if (navigator.platform.indexOf("Win") > -1 && ps) {
			ps.destroy();
			document.body.classList.toggle("perfect-scrollbar-on");
		}
	}
	componentDidUpdate(e) {
		if (e.history.action === "PUSH") {
			this.mainPanel.current.scrollTop = 0;
			document.scrollingElement.scrollTop = 0;
		}
	}

	administratorPrivileges() {
		const user = JSON.parse(localStorage.getItem('user'));
		if (user.role == "ADMIN") {
			routes.push({
				path: "/dashboard",
				name: "Dashboard",
				icon: "fas fa-tachometer-alt",
				component: DashboardX,
				layout: "",
			})

			// Gắn cờ divider: true
			routes.push({
				divider: true,
				path: "/divider",
				name: "divider",
				layout: "",
			});
		}

		routes.push({
			path: "/orders-id",
			name: "Xử lý đơn hàng",
			icon: "fas fa-receipt",
			component: Orders,
			layout: "",
		})

		routes.push({
			path: "/history",
			name: "Lịch sử thao tác",
			icon: "fas fa-history",
			component: LichSu,
			layout: "",
		})

		// Gắn cờ divider: true
		routes.push({
			divider: true,
			path: "/divider",
			name: "divider",
			layout: "",
		});
	}

	logged() {
		const user = JSON.parse(localStorage.getItem('user'));
		if (!user) {
			window.location = "/login";
			return;
		}
	}


	getToolFromServer() {
		Tool.getTool().then((res) => {
			let arrTool = res.data.map(value => ({
				path: `/${value.id}`,
				name: value.shortName || value.name,
				icon: value.icon || 'fas fa-cube',
				component: value.apiVersion >= 3 ? UserV3 : UserV1,
				layout: ""
			}));
			this.setState({ newRoutes: routes.concat(arrTool) })
		})
	}

	getTool() {
		const queryPath = window.location.pathname;
		return queryPath.replace(/admin/gi, '').replace(/[^a-zA-Z0-9 ]/g, '')
	}

	getBrand(arr) {
		let brandName = ''
		arr.map((prop) => {
			if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
				brandName = prop.name;
			}
			return null;
		});
		return brandName
	}

	handleMonthChange(month) {
		this.setState({ selectedMonth: month });
	}

	render() {
		const { newRoutes, selectedMonth } = this.state
		const isDashboard = window.location.pathname === '/dashboard';
		return (
			<div className="wrapper">
				<Sidebar
					{...this.props}
					routes={newRoutes}
					bgColor={this.state.backgroundColor}
					activeColor={this.state.activeColor}
				/>
				<div className="main-panel" ref={this.mainPanel}>
					<DemoNavbar
						title={this.getBrand(newRoutes)}
						isDashboard={isDashboard}
						selectedMonth={selectedMonth}
						onMonthChange={this.handleMonthChange}
						{...this.props}
					/>
					<Switch>
						{/* Routes cụ thể phải đặt trước routes có pattern */}
						<Route path="/orders-id/:id" component={OrderIDDetails} />
						{/* Render các route từ newRoutes */}
						{newRoutes.map((prop, key) => {
							if (prop.path === '/dashboard') {
								return (
									<Route exact path={prop.layout + prop.path} key={key}
										render={(routeProps) => <DashboardX {...routeProps} selectedMonth={selectedMonth} />}
									/>
								);
							}
							return (
								<Route exact path={prop.layout + prop.path} component={prop.component} key={key} />
							);
						})}
						{/* Route đặc biệt cho /:tool/:username phải đặt sau các routes cụ thể */}
						<Route path="/:tool/:username" component={UserV3} />
					</Switch>
					{/* <Footer fluid /> */}
				</div>
			</div>
		);
	}
}

export default Dashboard;
